import { render, staticRenderFns } from "./TaskBaseTable.vue?vue&type=template&id=4e034268"
import script from "./TaskBaseTable.vue?vue&type=script&lang=js"
export * from "./TaskBaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports